import Modal from 'react-bootstrap/Modal';
import Loader from '../../shared/Loader/Loader';
import ModalHeader from '../../Setup/Shared/ModalHeader';
import ModalFooter from '../../Setup/Shared/ModalFooter';
import NotificationHandler from '../../../utils/NotificationHandler';
import isNull from '../../../utils/NullChecking';
import { enumUtil } from '../../../utils/Enum';
import { ServerRequestProtected, ServerRequestPublic } from '../../../utils/ServerDataRequest';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import DropdownValueHandler from '../../shared/SuperSearch/DropdownValueHandler';
import FormValidator from '../../../utils/FormValidator';
import SuperSearchList from '../../shared/SuperSearch/SuperSearchList';
import { IconAudio } from '../../shared/IconsComponent/icons';
import ViewTestResults from './ViewTestResults';


const AddNewAITranscript = (props) => {
    // let IsDeleteAllowed = FindSecondChild('Setup', 'Services', 'Services')?.IsDeleted
    let IsDeleteAllowed = 'true'
    // let IsEditAllowed = FindSecondChild('Setup', 'Services', 'Services')?.IsAdd
    let IsEditAllowed = 'true'
    const { isOpenNewPrompt, handleClose, promptID, onDeletePrompt } = { ...props }
    let valModal = {}
    let ValidationModal = {
        NoteTypeVal: "",
        TranscriptVal: "",
        AudioVal: ""
    }
    let Prompt_Modal = {
        PromptName: null,
        Description: "",
        NoteType: "",
        transcript: "",
    }
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer)
    let noteTypes = useSelector(state => state.NoteTypeDDReducer);
    // let noteTypes = [
    //     { value: 'Case Management DAPP', display: 'Case Management DAPP' },
    //     { value: 'Individual Therapy DAPP', display: 'Individual Therapy DAPP' },
    //     { value: 'Neurofeedback DAPP', display: 'Neurofeedback DAPP' },
    //     { value: 'Nutrition CM DAPP', display: 'Nutrition CM DAPP' },
    //     { value: 'Peer Support DAPP', display: 'Peer Support DAPP' },
    //     { value: 'ASAM', display: 'ASAM' }
    // ]
    const [PromptID, setPromptID] = useState()
    const [PromptValidationModal, setPromptValidationModal] = useState(ValidationModal)
    const [PromptSaveUpdateModal, setPromptSaveUpdateModal] = useState({})
    const [AddPrompt, setAddPrompt] = useState('AddTranscript')
    const [mainPromptModal, setmainPromptModal] = useState(Prompt_Modal);
    const [isLoading, setIsLoading] = useState(false)
    const API_URL = enumUtil.controller.AITool
    const [OnPromptSave, setOnPromptSave] = useState(false)
    const [isPromptModalVisible, setIsPromptModalVisible] = useState(true);
    const [is, setIs] = useState(false);
    useEffect(() => {
        if (props.promptID != null) {
            setPromptID(props.promptID)
        } else {
            if (!OnPromptSave) {
                setPromptID(0);
            } else {
            }
        }
    }, [])
    useEffect(() => {
        if (!isNull(PromptID) && PromptID !== '0') {
            // setIsLoading(true)
            // ServerRequestProtected(API_URL + "/ClinicalNotesByID", 'post', {
            //     "ID": PromptID,
            //     "TableName": enumUtil.enumAPITableName.AIPromptDefinitions
            // }).then((response) => {
            //     setIs(true)
            //     setIsLoading(false)
            //     if (!isNull(response.NoteType)) {
            //         // setPromptSaveUpdateModal({ ...PromptSaveUpdateModal, NoteType: response.NoteType + "" })
            //     }
            //     response.NoteType = DropdownValueHandler(noteTypes, response.NoteType)
            //     setmainPromptModal(response)
            // }).catch((error) => {
            //     NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            //     setIsLoading(false)
            // })
        }
    }, [PromptID])
    const handlePromptChange = (e) => {
        let { name, value } = e.target;
        let modal = { ...mainPromptModal };
        let saveModal = { ...PromptSaveUpdateModal }
        modal[name] = value;
        for (var property in Prompt_Modal) {
            saveModal[name] = value
        }
        setmainPromptModal(modal)
        setPromptSaveUpdateModal(saveModal)
    }
    const handleChangeDD = (e) => {
        setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainPromptModal };
        modal[name] = value
        setmainPromptModal(modal)
    }
    const handleSelectedData = (selectedData, name, type) => {
        let modal = { ...mainPromptModal };
        let saveModal = { ...PromptSaveUpdateModal };

        if (type === 'client' && !isNull(selectedData)) {
            modal[name] = selectedData.display
            saveModal[name] = selectedData.value + ""

        } else if (type === 'server' && !isNull(selectedData)) {
            modal[name] = selectedData.display
            saveModal[name] = selectedData.value + ""
        } else {
            modal[name] = ''
            saveModal[name] = ''
        }
        setmainPromptModal(modal)
        setPromptSaveUpdateModal(saveModal)

        return selectedData
    }
    const PromptValidation = async () => {
        let ValidationModal = {
            NoteTypeVal: FormValidator(
                mainPromptModal.NoteType,
                enumUtil.enumValidationType.Required,
                'Note Type'
            )
        };

        if (AddPrompt === 'AddTranscript') {
            ValidationModal.TranscriptVal = FormValidator(
                mainPromptModal.transcript,
                enumUtil.enumValidationType.Required,
                'Transcript'
            );
        }
        else if (AddPrompt === 'AddAudio') {
            ValidationModal.TranscriptVal = FormValidator(
                audioFile,
                enumUtil.enumValidationType.Required,
                'Audio File'
            );
        }

        await setPromptValidationModal(ValidationModal);
        valModal = ValidationModal;
    };
    const handleSavePrompt = async () => {
        await PromptValidation()
        setPromptID(PromptID)
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            setPromptSaveUpdateModal(PromptSaveUpdateModal)
            const formData = new FormData();
            if (AddPrompt === 'AddAudio') {
                if (audioFile) {
                    formData.append("AudioFile", audioFile, "audio.webm");
                } else {
                    formData.append("AudioFile", null);
                }
            } else {
                formData.append("AudioFile", null);
            }
            if (AddPrompt === 'AddTranscript') {
                formData.append('Transcript', PromptSaveUpdateModal.transcript ? PromptSaveUpdateModal.transcript : '');
            } else {
                formData.append('Transcript', '');
            }
            formData.append('NoteType', PromptSaveUpdateModal.NoteType ? PromptSaveUpdateModal.NoteType : '');
            // let saveModal = {
            //     tableName: 'AIPROMPTDEFINITIONS',
            //     noteType: PromptSaveUpdateModal.NoteType,
            //     transcript: PromptSaveUpdateModal.transcript,
            // }
            setIsLoading(true)
            ServerRequestPublic(API_URL + "/Generate", 'post', formData, 'Upload')
                .then((response) => {
                    setIsLoading(false)
                    if (!isNull(response.id)) {
                        setPromptID(response.id)
                        handleViewResult(response.id, response.transcript)
                        setIsPromptModalVisible(false)
                    }
                    NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)

                    // }
                }).catch((error) => {
                    setIsLoading(false)
                    if (!isNull(error.response.data.error)) { NotificationHandler(error.response.data.error, enumUtil.enumtoaster.error) }
                    else { NotificationHandler(error.response.data.error, enumUtil.enumtoaster.error) }
                })
        }
    }
    const SetPromptName = () => {
        if (mainPromptModal.PromptName != null && mainPromptModal.PromptName != "") {
            return (
                <p className="heading">{mainPromptModal.PromptName}</p>
            )
        } else {
            return (
                <p className="heading">New Prompt</p>
            )
        }
    }
    const [audioFile, setAudioFile] = useState(null);
    const handleAudioChange = (e) => {
        const file = e.target.files?.[0];

        if (file) {
            setAudioFile(file);
            console.log(file);
        }
    };
    const handleClearFile = () => {
        setAudioFile(null)
        const fileInput = document.getElementById("EncounterSOAPDocument");
        if (fileInput) {
            fileInput.value = "";
        }
    }
    // view results
    const [isViewResult, setIsViewResult] = useState(false)
    const [resultID, setResultID] = useState(null)
    const [otherData, setOtherData] = useState({
        Transcript: '',
        NoteType: ''
    })
    const handleViewResult = (id, transcript) => {
        setIsViewResult(true)
        setResultID(id + "")
        setOtherData({
            Transcript: transcript ? transcript : PromptSaveUpdateModal.transcript,
            NoteType: PromptSaveUpdateModal.NoteType,
        })
    }
    const onCloseViewResult = () => {
        setIsViewResult(false)
        setOtherData({
            Transcript: '',
            NoteType: ''
        })
        setResultID(null)
        setOnPromptSave(true)
        onDeletePrompt()
        setIsPromptModalVisible(false);
    }
    let viewResultPopup
    if (isViewResult) {
        viewResultPopup = <ViewTestResults isViewResult={isViewResult} onClose={onCloseViewResult} id={resultID} otherData={otherData} />
    }
    return (
        <>
            {viewResultPopup}
            <Modal show={isPromptModalVisible} onHide={handleClose} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_add_prompt_popup">
                {isLoading ? <Loader /> : null}
                <Modal.Body>
                    <ModalHeader HeaderName={SetPromptName} isOpenAudit={null} handleAuditModal={() => { }} DeletePopup={''} isClosed={OnPromptSave ? onDeletePrompt : handleClose} key={'001'} Name={'CustomPrompts'} IsDeleteAllowed={IsDeleteAllowed} />
                    <div className="d-flex align-items-center gap-15 mb-10 pb-1">
                        <label className="ar_radio-btn d-flex align-items-center gap-6">
                            <input
                                type="radio"
                                id="AddTranscript"
                                checked={AddPrompt === 'AddTranscript'}
                                onChange={() => { setAddPrompt('AddTranscript') }}
                            />
                            <p className="text ar-orange-text lh-1 user-select-none" htmlFor="AddTranscript">Add Transcript</p>
                        </label>
                        <label className="ar_radio-btn d-flex align-items-center gap-6">
                            <input
                                type="radio"
                                id="AddAudio"
                                checked={AddPrompt === 'AddAudio'}
                                onChange={() => { setAddPrompt('AddAudio') }}
                            />
                            <p className="text ar-orange-text lh-1 user-select-none" htmlFor="AddAudio">Add Audio</p>
                        </label>

                    </div>


                    {AddPrompt === 'AddTranscript' ?
                        <div className="d-flex flex-column gap-2">
                            <div className={PromptValidationModal.TranscriptVal ? "input mb-0 error" : "input mb-0"}>
                                <label className='text fs-12 ar-light-color '>Transcript <span className='req'>*</span></label>
                                <textarea
                                    type="text"
                                    rows={11}
                                    className='form-control'
                                    name="transcript"
                                    id="transcript"
                                    value={mainPromptModal.transcript}
                                    onChange={handlePromptChange}
                                />
                                {PromptValidationModal.TranscriptVal}
                            </div>
                            <div className={PromptValidationModal.NoteTypeVal ? "input mb-0 error" : "input mb-0"}>
                                <label className='text fs-12 ar-light-color '> Note Type <span className='req'>*</span></label>
                                <SuperSearchList
                                    type="client"
                                    id='NoteType'
                                    name='NoteType'
                                    searchValue={mainPromptModal.NoteType}
                                    data={noteTypes?.filter(item => item.IsAIEnabled === true) || []}
                                    onChange={handleChangeDD}
                                    getSelectedData={handleSelectedData}
                                    is={is}
                                    sup_btn='sup_btn-Inp'
                                    sup_inp='superSearchVisitInp'
                                    icon='Simple'
                                    inputError={PromptValidationModal.NoteTypeVal}
                                />
                            </div>
                            {/* <div className={PromptValidationModal.PromptNameVal ? "input mb-0 error" : "input mb-0"} >
                            <label className='text fs-12 ar-light-color '>Prompt Name <span className='req'>*</span></label>
                            <input
                                type="text"
                                className='form-control'
                                value={mainPromptModal.PromptName}
                                name="PromptName"
                                id="PromptName"
                                onChange={handlePromptChange}
                            />
                            {PromptValidationModal.PromptNameVal}
                        </div>
                        <div className="input mb-0">
                            <label className='text fs-12 ar-light-color '>Description</label>
                            <textarea
                                type="text"
                                rows={5}
                                className='form-control'
                                name="Description"
                                id="Description"
                                value={mainPromptModal.Description}
                                onChange={handlePromptChange}
                            />
                        </div> */}
                        </div>
                        :
                        <div className="d-flex flex-column gap-2">
                            <div className={PromptValidationModal.audioFile ? "form-group input mb-0 error" : "form-group input mb-0"}>
                                {audioFile ? (
                                    <div className="d-flex align-items-center justify-content-between gap-20 w-100 text-nowrap cursor-pointe form-control upload-file">
                                        <p className='text text-black min-w-0 validation_message'>{audioFile.name}</p>
                                        <i className='icon-x-cros text-black fs-16 fw-900' onClick={(e) => {
                                            e.preventDefault(); e.stopPropagation();
                                            handleClearFile();
                                        }}></i>
                                    </div>
                                )
                                    : (
                                        <div className="d-flex position-relative">
                                            <input
                                                type="file"
                                                id="EncounterSOAPDocument"
                                                name="EncounterSOAPDocument"
                                                className="d-block opacity-0 w-100 position-absolute"
                                                accept=".mp3,.webm"
                                                onChange={handleAudioChange}
                                            />

                                            <label className="flex-center gap-5 w-100 text-nowrap cursor-pointe form-control upload-file" htmlFor='EncounterSOAPDocument'>
                                                <IconAudio />
                                                <p className='text fs-11 fst-italic text-black'>Upload an Audio File</p>
                                            </label>

                                            {PromptValidationModal.audioFile}
                                        </div>
                                    )
                                }
                            </div>

                            <div className={PromptValidationModal.NoteTypeVal ? "input mb-0 error" : "input mb-0"}>
                                <label className='text fs-12 ar-light-color '> Note Type <span className='req'>*</span></label>
                                <SuperSearchList
                                    type="client"
                                    id='NoteType'
                                    name='NoteType'
                                    searchValue={mainPromptModal.NoteType}
                                    data={noteTypes?.filter(item => item.IsAIEnabled === true) || []}
                                    onChange={handleChangeDD}
                                    getSelectedData={handleSelectedData}
                                    is={is}
                                    sup_btn='sup_btn-Inp'
                                    sup_inp='superSearchVisitInp'
                                    icon='Simple'
                                    inputError={PromptValidationModal.NoteTypeVal}

                                />
                            </div>
                        </div>
                    }

                </Modal.Body>
                <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-between gap-2 ar_footer">
                    {/* <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={handleClose}>Cancel</button> */}
                    <div className="">
                        {/* <p className='heading fs-10 linear-blue-color'>Generating Transcript...</p> */}
                    </div>

                    <button className='btn btn-validate px-10 h-100' onClick={handleSavePrompt}>Proceed</button>
                </div>
                {/* <ModalFooter isSaved={OnPromptSave ? onDeletePrompt : handleClose} handleSave={handleSavePrompt} UpdatedDate={mainPromptModal.UpdatedDate} UpdatedBy={mainPromptModal.UpdatedBy} ID={PromptID} IsEditAllowed={IsEditAllowed} /> */}


            </Modal>
        </>
    )
}

export default AddNewAITranscript